export interface InternalUserExperiment {
  group: string
  name: string
}

export const getExperimentGroupName = (
  userExperimentsArray: InternalUserExperiment[] = [],
  experimentName: string
) => {
  const experiment = userExperimentsArray.find(
    (experiment) => experiment.name === experimentName
  )
  return experiment?.group || null
}

const isInExperiment = (
  userExperimentsArray: InternalUserExperiment[] = [],
  experimentName: string,
  experimentGroup = 'experiment'
) =>
  userExperimentsArray.some(
    (experiment: InternalUserExperiment) =>
      experiment.name === experimentName && experiment.group === experimentGroup
  )

export default isInExperiment
